import React from 'react';
import { TFunction } from 'i18next';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import ButtonLink from '@teetsh/app/src/components/Buttons/Link';
import { InfoboxLayout } from 'components/Callout/Infobox';

export function getErrorMessage(
  error: string | null,
  t: TFunction<'common'>,
):
  | {
      title: string;
      actions?: React.ReactNode;
      layout?: InfoboxLayout;
    }
  | undefined {
  if (!error) return undefined;

  if (error === 'quota_exceeded') {
    return {
      layout: 'block',
      title: t('messages.iaQuotaExceeded'),
      actions: (
        <ButtonLink
          intent="warning"
          rightIcon={ArrowRightIcon}
          outlined
          to="/settings/usage"
          tw="mt-4 ml-auto"
        >
          {t('buttons.goToSettings')}
        </ButtonLink>
      ),
    };
  }

  return { title: t('messages.genericError') };
}
